import type { IPerformanceKeyResult, IRewardCategory, IUser } from '@/types/Data'
import { KeyResultWeightValue } from '@/types/Enums/Performance'
import slugify from 'slugify'

export const Slugger = (text: string) => {
  return slugify(text, {
    replacement: '-',
    locale: 'en',
    lower: true,
    remove: /[*+~.()'"!:@]/g,
  })
}

export const FlattenObject = (object: any, name: string) => {
  const propObj = object[name]

  for (const prop in propObj) {
    const newProp = `${name}${prop.charAt(0).toUpperCase()}${prop.slice(1)}`
    object[newProp] = propObj[prop]
  }

  delete object[name]

  return object
}

export const Debounce = <T extends (...args: any[]) => void>(fn: T, delay: number) => {
  let timeoutID: ReturnType<typeof setTimeout> | null = null
  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(timeoutID!)
    timeoutID = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export const UserMerger = (user: IUser) => {
  const merged = { ...user } as any
  const employee = merged.employee

  for (const prop in employee) {
    if (Object.hasOwn(employee, prop)) {
      const userVal = merged[prop]
      const employeeVal = employee[prop]

      merged[prop] = HasValue(userVal) ? userVal : employeeVal
    }
  }

  delete (merged as { employee?: any }).employee
  const response: any = merged
  response.employeeId = user.employee.id
  return response
}

export const HasValue = (value: any) => {
  return value !== undefined && value !== null && value !== ''
}

export const FindCategoryInSubtree = (
  items: IRewardCategory[],
  targetId: string,
): IRewardCategory | null => {
  for (const item of items) {
    if (item.id === targetId) return item
    if (item.subCategories?.length && FindCategoryInSubtree(item.subCategories, targetId)) {
      return item
    }
  }
  return null
}

export const CalculateKeyResultPercentage = (keyResults: IPerformanceKeyResult[]) => {
  if (!keyResults.length) return keyResults.map(k => ({ ...k, weightPercentage: 0 }))
  const values: number[] = keyResults.map(
    k => KeyResultWeightValue[k.weight as unknown as keyof typeof KeyResultWeightValue],
  )

  const total = values.reduce((acc, curr) => acc + curr, 0)

  const percentages = values.map(v => Number.parseFloat(((v / total) * 100).toFixed(2)))

  // Toplam farkını son elemana ekle (yuvarlama hatasını gidermek için)
  const diff = 100 - percentages.reduce((acc, curr) => acc + curr, 0)
  percentages[percentages.length - 1] = Number.parseFloat(
    ((percentages.at(-1) ?? 0) + diff).toFixed(2),
  )

  // Her KR objesine yüzdesini yaz
  keyResults.forEach((kr, i) => {
    kr.weightPercentage = percentages[i] ?? 0
  })

  return keyResults
}
